import axios from 'axios';
import router from "@/router";
import AuthTokenCache from "@/cache/auth-token.cache";
import store from "@/store";

axios.defaults.baseURL = `${import.meta.env.VITE_API_URL}/api/v1/`;
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.withCredentials = false;

axios.interceptors.request.use(
    function (config) {
        const token = AuthTokenCache.get();
        const is_superadmin = localStorage.getItem('is_superadmin');
        const is_superadmin_roles = localStorage.getItem('is_superadmin_roles');
        const is_superadmin_id = localStorage.getItem('is_superadmin_id');

        if (token) {
            config.headers.Authorization = `Bearer ${ token }`;
        }

        if (is_superadmin === 'true') {
            config.headers['X-Superadmin-Mode'] = 'true';
        }

        if (is_superadmin_roles) {
            config.headers['X-Superadmin-Roles-Mode'] = is_superadmin_roles;
        }

        if (is_superadmin_id) {
            config.headers['X-Superadmin-Id-Mode'] = is_superadmin_id;
        }

        if (document.cookie.includes("dev_debug")) {
            const url = new URL(config.url, window.location.origin);
            url.searchParams.set("XDEBUG_SESSION_START", "PHPSTORM");
            config.url = url.pathname + url.search;
        }

        return config;
    },
);
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response?.status === 401) {
            AuthTokenCache.clear();
        }

        const errorText = error?.response?.data?.errorType;

        if (errorText === 'emptyRequiredFields') {
            router.push({
                name: store.getters.authUser?.registrationStep !== null ? 'FinishSignup' : 'UserCabinet'
            })
        }
        if (errorText === 'showAgreements') router.push({ name: 'Agreements' })
        if (errorText === 'setPermanentPassword') router.push({ name: 'SetPermanentPassword' })

        return Promise.reject(error.response ?? error);
    }
)

export default axios;